module.exports = __webpack_public_path__ + "media/images/banner/tamatex/banner-b705634cc8feeb7905f47e90186cdcd2.png";